import { render, staticRenderFns } from "./pending-collection-query.vue?vue&type=template&id=40a81d80&scoped=true"
import script from "./pending-collection-query.vue?vue&type=script&lang=ts"
export * from "./pending-collection-query.vue?vue&type=script&lang=ts"
import style0 from "./pending-collection-query.vue?vue&type=style&index=0&id=40a81d80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a81d80",
  null
  
)

export default component.exports